<template>
    <!-- 編輯頁面本體-->
    <div class="incsall ">
        <!--切換語系區塊-->
        <div class="language_div p-3 mb-2">
            <button id="toTw" :class="'btn '+(this.lang == '1' ?'btn-danger selected':'btn-secondary')" @click="toLang('tw')">中文版</button>
            <button id="toEn" :class="'btn '+(this.lang == '2' ?'btn-danger selected':'btn-secondary')" @click="toLang('en')">英文版</button>
        </div>

        <!--標題區塊-->
        <div class="title_div p-3 mb-2 bkbor">
            <label class="text-danger" for="title">標題*</label>
            <b-form-input 
                name="title"
                placeholder="請輸入標題"
                required
                maxlength="200" v-model="content.title">
            </b-form-input>
        </div>
        <!--設定區塊-->
        <!--單一頁面不能設定發佈狀態及上下架時間-->
        <!--b-form-group class="status_div p-3 mb-2 bkbor" label-size="lg" >
            <b-row>
                <b-col>
                    <label class="text-danger" for="startDate">上架時間*</label>
                    <b-form-datepicker 
                        name="startDate"
                        class="mb-2"  
                        clear-button
                        placeholder="選擇上架日期" 
                        v-model="content.startDate">
                    </b-form-datepicker>
                </b-col>
                <b-col>
                    <label for="endDate">下架時間</label>
                    <b-form-datepicker 
                        name="endDate"
                        class="mb-2"  
                        clear-button
                        placeholder="選擇下架日期" 
                        v-model="content.endDate">
                    </b-form-datepicker>
                </b-col>
                <b-col>
                    <label class="text-danger" for="Displaystatus">發布狀態*</label>
                    <b-form-select 
                        name="Displaystatus"
                        class="only-button-down"
                        v-model="content.status"
                        :options="statusOption">
                    </b-form-select>
                </b-col>
            </b-row>
        </b-form-group-->
        <!--主內容區塊-->
        <b-form-group label-size="lg" class="p-4 mb-2 bkmn mt-3">
            <!--內文-->
            <b-row>
                <b-col>
                    <label>內文</label>
                    <TinyMceEditor id="vue-tinymce" v-model="content.description">

                    </TinyMceEditor>
                </b-col>
            </b-row>
        </b-form-group>
        <!--後台系統紀錄區塊 (若無資料則不顯示)-->
        <b-form-group class="status_div p-3 mb-2 bkbor" label-size="lg" 
            v-if="content.creatorName ||content.modifierName">
            <!--建檔記錄-->
            <b-row 
                v-if="content.creatorName">
                <b-col>
                    <span>建檔紀錄：</span>
                    <!--建檔記錄格式 = 建檔帳號(建立時間 yyyy-mm-dd HH:MM:ss) -->
                    <span>{{content.creatorName}}({{ datetimeFormatFloat(content.createDate) }})</span>
                </b-col>
            </b-row>
            <!--異動紀錄-->
            <b-row 
                v-if="content.modifierName">
                <b-col>
                    <span>異動紀錄：</span>
                    <!--異動記錄格式 = 異動帳號(異動時間 yyyy-mm-dd HH:MM:ss) -->
                    <span>{{content.modifierName}}({{ datetimeFormatFloat(content.modifyDate) }})</span>
                </b-col>
            </b-row>
        </b-form-group>
        <!--操作功能區塊-->
        <div class="Operation_div"> 
            <b-button id="save_btn" class="btn btn-secondary" @click="save" v-if="permission.isUpdate" >儲存</b-button>
        </div>
    </div>
</template>

<script>
import TinyMceEditor from "../../Tool/TinyMecEditor.vue";
export default{ 
    
    components:{
        TinyMceEditor
    },
    data(){
        return{
            //類別編號
            PJ_ID:"",
            typeId: "",
            //文章編號
            id:"", 
            //語系
            lang:"",
            //樣式編號
            modal:"",
            //文章內容
            content:{
                title:"",
                description:"",
                creatorName:"",
                createDate:"",
                modifierName:"",
                modifyDate:"",
            },
            //發布狀態選項
            statusOption:[
                {value:null,text:"請選擇"},
                {value:0,text:"關閉"},
                {value:1,text:"開啟"},
            ],
            //初始化中
            isInit:true,
            //異動警告
            isEdited:false,
            //是否更新
            isUpdate:false,
            //權限設定
            pagepermission:{},
            //API設定區
            apiMemory:(data) => this.userRequest.post("bicd/Member",data),

        };
    },
    props:["value"],
    computed:{
    },
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        value(){
            //初始化
            this.init();
        },
        content(){
            if(!this.isInit){
                //判斷資料內容是否有變更
                //TODO 判斷編輯更新狀態
                //this.isEdited = true;
            }
        },
        //權限
        permission(){
            this.pagepermission = this.permission;
        }
    },
    methods:{
        //初始化
        init(){
            //類別編號
            this.PJ_ID = this.value.PJID;
            //類別內部編號
            this.typeId = this.value.typeId;
            //文章編號
            this.id = this.value.id;
            //語系
            this.lang = this.value.lang?this.value.lang : 1;
            //樣式編號
            this.modal = this.value.modal;
            //是否為修改
            this.isUpdate = false;
            //取得畫面權限
            this.getPermission(this.PJ_ID);
            //取得文章內容
            this.getContent(); 
        },
        //取得內容資料
        async getContent(){
            try {
                //POST 參數
                let jsonReq = {
                    TYPE: "GetContent",
                    member_SELECT:{
                        id:this.id,
                        typeId:Number(this.typeId),
                        langurage: Number(this.lang),
                        model: this.modal,
                    }
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/Member",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if (json.Status){
                    if (json.Data != "null"){
                        //有資料時，讀取資料並切換成修改模式
                        let jsonData =JSON.parse(json.Data);
                        this.content = {
                            id: jsonData.id,
                            title:jsonData.title,
                            description:jsonData.description,
                            creatorName:jsonData.creatorName,
                            createDate:jsonData.createDate,
                            modifierName:jsonData.modifierName,
                            modifyDate:jsonData.modifyDate,
                        };
                        this.id = jsonData.id;
                        //更改狀態為修改
                        this.isUpdate = true;
                    }else{
                        //預設空值
                        this.content = {
                            id:0,
                            title:"",
                            description:"",
                            creatorName:"",
                            createDate:"",
                            modifierName:"",
                            modifyDate:"",
                        };
                        //更改狀態為新增
                        this.isUpdate = false
                    }
                }
            }catch(err){
                console.log("ErrorFunction: getContent/n "+err);
            }
        },
        //儲存
        save(){
            //將目前資訊整合，並送出
            let json_list = {
                id:(this.id)?Number(this.id):0,
                typeId: Number(this.typeId),
                startDate: new Date(),
                endDate: null,
                title:this.content.title,
                description: this.content.description,
                sort: this.content.createDate.sort,
                deployStatus:1,
                langurage: Number(this.lang),
            }
            if(this.isUpdate){
                //修改功能
                let json ={
                    TYPE:"UPDATE",
                    VerifyCode:this.PJ_ID ,
                    member_UPDATE:json_list,
                };

                this.FunctionToken(this.functionUpdate,json);
            }else{
               //新增功能
                let json={
                    TYPE:"INSERT",
                    VerifyCode:this.PJ_ID ,
                    member_INSERT:json_list,
                };
                
                this.FunctionToken(this.functionInsert,json);
            }
           
        },
        //新增功能
        functionInsert(data){
            this.apiMemory(data)
                .then((res) => {
                    let json = JSON.parse(res.data);
                    if (json.Status){
                        //this.$bvToast.toast("新增成功",{title:"提示",solid:true,});
                        alert("新增成功");
                        //切換成更新模式
                        this.isUpdate = true;
                        //設定回傳的編號
                        this.id= json.Data;
                        //已儲存關閉為更新通知
                        this.isEdited = false;
                    }else{
                        //發生錯誤時，跳出提示                        
                        alert(this.Str_Replace(JSON.parse(json.Data),",","\r\n"));
                    }
                })
                .catch((err) =>{
                    console.log("ErrorFunction: functionInsert/n" ,err);
                });
        },
        //更新功能
        functionUpdate(data){
            this.apiMemory(data)
                .then((res) => {
                    let json= JSON.parse(res.data);
                    if(json.Status){
                        //this.$bvToast.toast("更新成功",{title:"提示",solid:true,});
                        alert("更新成功");
                        //已儲存關閉為更新通知
                        this.isEdited = false;
                    }else{
                        //發生錯誤時，跳出提示
                        alert(this.Str_Replace(JSON.parse(json.Data),",","\r\n"));
                    }
                })
                .catch((err)=>{

                    console.log("ErrorFunction: functionInsert/n" ,err);
                });
        },
        //切換語系
        toLang(click_lang){
            
            if(click_lang == 'tw' && this.lang != '1'){
                //進入中文介面 
                if (this.isEdited){
                    //確認是否不儲存就離開
                    if(!confirm("還有尚未儲存的資料，請問是否直接離開")){
                        return;
                    }
                }
                this._go("?PJID="+this.PJ_ID + "&typeId="+this.typeId +"&modal="+this.modal+((this.id != undefined && this.id != '')?"&id="+this.id:"")+"&lang=1");
                
            }else if(click_lang == 'en'&& this.lang != '2'){
                //進入英文介面
                if(this.isEdited){
                    //確認是否不儲存就離開
                    if(!confirm("還有尚未儲存的資料，請問是否直接離開")){
                        return;
                    }
                }
                this._go("?PJID="+this.PJ_ID + "&typeId="+this.typeId +"&modal="+this.modal+((this.id != undefined && this.id != '')?"&id="+this.id:"")+"&lang=2");
            }
        },

    }
}
</script>